module.exports = __webpack_public_path__ + "img/faq-senior.7a3e053b.jpg";